import { render } from "./VitrineView.vue?vue&type=template&id=ea35faa4&scoped=true"
import script from "./VitrineView.vue?vue&type=script&lang=js"
export * from "./VitrineView.vue?vue&type=script&lang=js"

import "./VitrineView.vue?vue&type=style&index=0&id=ea35faa4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea35faa4"]])

export default __exports__